import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotFoundComponent } from "./miscellaneous/not-found/not-found.component";
import { PagesComponent } from "./pages.component";
import { AuthGuard } from "../@core/auth/authGuard";
import { alinaGuard } from "./ai-chatwoot-buddy/ALINA-permission/alina.guard";
import { TownhallAdminGuard } from "./townhall/townhall-admin-guard";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'applications',
        loadChildren: () => import("./applications/applications.module").then((m) => m.ApplicationsModule)
      },
      {
        path: 'my-team',
        loadChildren: () => import("./my-team/my-team.module").then((m) => m.MyTeamModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'my-team-v2',
        loadChildren: () => import("./my-team-v2/my-team.module").then((m) => m.MyTeamModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      // {
      //   path: 'mood-Analytics',
      //   loadChildren: () => import("./gauge-chart/gauge-chart.module").then((m) => m.GaugeChartModule),
      //   canActivate: [
      //     MsalGuard,AuthGuard
      //   ]
      // },
      {
        path: 'mood-Graph',
        loadChildren: () => import("./mood-graph/mood-graph.module").then((m) => m.MoodGraphModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'feed',
        loadChildren: () => import("./feed/feed-section/feed-section.module").then((m) => m.FeedSectionModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'feed-details/:id',
        loadChildren: () => import("./feed/feed-details/feed-details.module").then((m) => m.FeedDetailsModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'departments',
        loadChildren: () => import("./main-department/main-department.module").then((m) => m.MainDepartmentModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'departments/HROperations',
        loadChildren: () => import("./main-department/hroperations/hroperations.module").then((m) => m.HroperationsModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'departments/FAlegal',
        loadChildren: () => import("./main-department/falegal/falegal.module").then((m) => m.FAlegalModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
       {
        path: 'departments/Quality',
        loadChildren: () => import("./main-department/quality/quality.module").then((m) => m.QualityModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'departments/Dataprivacy',
        loadChildren: () => import("./main-department/dataprivacy/dataprivacy.module").then((m) => m.DataprivacyModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
       {
        path: 'departments/Procurement',
        loadChildren: () => import("./main-department/procurement/procurement.module").then((m) => m.ProcurementModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'departments/Marketing',
        loadChildren: () => import("./main-department/marketing/marketing.module").then((m) => m.MarketingModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'board-of-directors',
        loadChildren: () => import('./board-of-director/board-of-director.module').then((m) => m.BoardOfDirectorModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'departments/Admin',
        loadChildren: () => import("./main-department/admin/admin.module").then((m) => m.AdminModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
        {
        path: 'departments/Admin/Bangalore',
        loadChildren: () => import("./main-department/admin/bangalore-admin/bangalore-admin.module").then((m) => m.BangaloreAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
       {
        path: 'departments/Admin/Chennai',
        loadChildren: () => import("./main-department/admin/chennai-admin/chennai-admin.module").then((m) => m.ChennaiAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'departments/Admin/Hyderabad',
        loadChildren: () => import("./main-department/admin/hyderabad-admin/hyderabad-admin.module").then((m) => m.HyderabadAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'departments/Admin/Mumbai',
        loadChildren: () => import("./main-department/admin/mumbai-admin/mumbai-admin.module").then((m) => m.MumbaiAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'departments/Admin/Mysore',
        loadChildren: () => import("./main-department/admin/mysore-admin/mysore-admin.module").then((m) => m.MysoreAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'departments/Admin/Pune',
        loadChildren: () => import("./main-department/admin/pune-admin/pune-admin.module").then((m) => m.PuneAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'departments/Admin/Vadodara',
        loadChildren: () => import("./main-department/admin/vadodara-admin/vadodara-admin.module").then((m) => m.VadodaraAdminModule),
        canActivate: [
          AuthGuard
        ]
      },
      {path:'talentai',
        loadComponent: () => import("./talentai/talentai.component").then((m) => m.TalentaiComponent),
        canActivate: [
         
          MsalGuard,AuthGuard
        ]
      },
      {path:'pulse365',
        loadComponent: () => import("./pulse365/pulse365.component").then((m) => m.Pulse365Component),
        canActivate: [
         
          MsalGuard,AuthGuard
        ]
      },
      
      // {
      //   path: 'lander-page',
      //   loadChildren: () => import("./lander-page/lander-page.module").then((m) => m.LanderPageModule)
      // },
      // {
      //   path: 'genie',
      //   loadChildren: () => import("./genie-chatbot/genie-chatbot.module").then((m) => m.GenieChatbotModule)
      // },
      {
        path: 'data-upload-backend',
        loadChildren: () => import('./data-upload-backend/data-upload-backend.module').then(m => m.DataUploadBackendModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'content-upload',
        loadChildren: () => import('./data-upload-backend/content-upload/content-upload.module').then(m => m.ContentUploadModule),
        canActivate: [
          AuthGuard
        ]
      },
      // {
      //   path: 'townhall',
      //   loadChildren: () => import('./townhall/townhall.module').then(m => m.TownhallModule)
      // },
      {
        path: 'event-details/:id',
        loadComponent: () => import('./townhall/event-details/event-details.component').then(m => m.EventDetailsComponent),
        canActivate: [
          MsalGuard,AuthGuard,
        ]
      },
      {path:'townhall',
        loadComponent: () => import("./townhall/townhall.component").then((m) => m.TownhallComponent),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'view-details/:id',
        loadComponent: () => import('./townhall/view-details/view-details.component').then((m) => m.ViewDetailsComponent),
        canActivate: [
          MsalGuard,AuthGuard,
          TownhallAdminGuard
        ]
      },
      {
        path: 'preview-details/:id',
        loadChildren: () => import('./data-upload-backend/preview-details/preview-details.module').then((m) => m.PreviewDetailsModule),
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: 'LINA',
        loadChildren: () => import('./ai-chatwoot-buddy/ai-chatwoot-buddy.module').then(m => m.AiChatwootBuddyModule),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      {
        path: 'declaration',
        loadComponent: () => import('./declaration/declaration.component').then(m => m.DeclarationComponent),
        canActivate: [
          MsalGuard,AuthGuard
        ]
      },
      //FOR FUTURE REFERENCE...DO NOT REMOVE
      // {
      //   path: "layout",
      //   loadChildren: () =>
      //     import("./layout/layout.module").then((m) => m.LayoutModule),
      // },
      // {
      //   path: "forms",
      //   loadChildren: () =>
      //     import("./forms/forms.module").then((m) => m.FormsModule),
      // },
      // {
      //   path: "ui-features",
      //   loadChildren: () =>
      //     import("./ui-features/ui-features.module").then(
      //       (m) => m.UiFeaturesModule
      //     ),
      // },
      // {
      //   path: "modal-overlays",
      //   loadChildren: () =>
      //     import("./modal-overlays/modal-overlays.module").then(
      //       (m) => m.ModalOverlaysModule
      //     ),
      // },
      // {
      //   path: "extra-components",
      //   loadChildren: () =>
      //     import("./extra-components/extra-components.module").then(
      //       (m) => m.ExtraComponentsModule
      //     ),
      // },
      // {
      //   path: "maps",
      //   loadChildren: () =>
      //     import("./maps/maps.module").then((m) => m.MapsModule),
      // },
      // {
      //   path: "charts",
      //   loadChildren: () =>
      //     import("./charts/charts.module").then((m) => m.ChartsModule),
      // },
      // {
      //   path: "editors",
      //   loadChildren: () =>
      //     import("./editors/editors.module").then((m) => m.EditorsModule),
      // },
      // {
      //   path: "tables",
      //   loadChildren: () =>
      //     import("./tables/tables.module").then((m) => m.TablesModule),
      // },
      // {
      //   path: "miscellaneous",
      //   loadChildren: () =>
      //     import("./miscellaneous/miscellaneous.module").then(
      //       (m) => m.MiscellaneousModule
      //     ),
      // },
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "**",
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
